"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClient = void 0;
const react_1 = require("react");
const fetching_1 = require("./fetching");
const lib_1 = require("../lib");
function useClient() {
    const { cache } = (0, lib_1.useAppContext)();
    const { locale } = (0, lib_1.useTranslation)();
    return (0, react_1.useMemo)(() => (0, fetching_1.createClient)({ cache, lang: locale }), [cache, locale]);
}
exports.useClient = useClient;
